<div class="main-container d-flex flex-column h-100" [class.paddingLeft]="isSidebarExpanded">

  <div class="header d-flex justify-content-between align-items-center headerfix" style="flex-wrap: nowrap;">
    <div>
      <p class="fs-16 fw-600 mb-2">View Applicants</p>
      <span class="text-muted small">Tracking Medical Evidence Requests and Collections</span>
    </div>

    <div class="d-flex gap-2 flex-nowrap align-items-center">

      @if(MemberInsurerServiceService.getLoginUserRole() == enumRole.INSURER) {
      <div class="d-flex align-items-center justify-content-end gap-3 flex-nowrap w-100">


        <div class="slide-filter-container">
          <span class="actionIcon cursor-pointer" (click)="toggleFilter()" matTooltip="Filter by status"
            matTooltipPosition="above">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
              <path fill="#0075C9"
                d="M14.037 20.937a1 1 0 0 1-.518-.145l-3.334-2a2.55 2.55 0 0 1-1.233-2.176v-4.525a1.53 1.53 0 0 0-.284-.891L4.013 4.658a1.01 1.01 0 0 1 .822-1.6h14.33a1.009 1.009 0 0 1 .822 1.6L15.332 11.2a1.53 1.53 0 0 0-.285.891v7.834a1.013 1.013 0 0 1-1.01 1.012M4.835 4.063l4.647 6.557a2.5 2.5 0 0 1 .47 1.471v4.524a1.54 1.54 0 0 0 .747 1.318l3.334 2l.014-7.843a2.5 2.5 0 0 1 .471-1.471l4.654-6.542Z" />
            </svg>
          </span>

          <div class="slide-chips-wrapper" [class.open]="isFilterExpanded">
            <button class="scroll-button" (click)="scrollChips('left')"  >
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 48 48"
                class="flip-horizontal">
                <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                  d="M40.915 22.987L12.931 6.831a1.17 1.17 0 0 0-1.754 1.012v32.314c0 .9.975 1.462 1.754 1.012l27.984-16.156a1.17 1.17 0 0 0 0-2.026M11.177 8.518L8.254 6.831A1.17 1.17 0 0 0 6.5 7.843v32.314c0 .9.974 1.462 1.754 1.012l2.923-1.687"
                  stroke-width="1" />
              </svg>
            </button>

            <div class="chip-list" #chipList>
              <button class="status-chip" *ngFor="let status of availableStatuses"
                [ngClass]="[status.colorClass, currentRequestFilterStatus === status.value ? 'active' : '']"
                (click)="selectStatus(status.value);$event.stopPropagation()">
                {{ status.label }}
              </button>
            </div>


            <button class="scroll-button" (click)="scrollChips('right')">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 48 48">
                <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                  d="M40.915 22.987L12.931 6.831a1.17 1.17 0 0 0-1.754 1.012v32.314c0 .9.975 1.462 1.754 1.012l27.984-16.156a1.17 1.17 0 0 0 0-2.026M11.177 8.518L8.254 6.831A1.17 1.17 0 0 0 6.5 7.843v32.314c0 .9.974 1.462 1.754 1.012l2.923-1.687"
                  stroke-width="1" />
              </svg>
            </button>
          </div>


        </div>


        <div class="clearFilters" (click)="clearFilters()" *ngIf="patientIdSelected || cardSelected">
          Clear filters
        </div>

        <div class="controls" matTooltip="View mode" matTooltipPosition="above">
          <app-view-mode-toggle [currentViewMode]="viewMode" (viewModeChange)="changeViewMode($event)">
          </app-view-mode-toggle>
        </div>

        <span class="cursor-pointer actionIcon" (click)="onRefresh()" matTooltip="refresh" matTooltipPosition="above">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24"
            [ngClass]="{ 'rotate-animation': isRotating }">
            <g fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.2">
              <path d="M6.446 10.512a5.75 5.75 0 0 0 8.429 6.468m2.679-3.492A5.75 5.75 0 0 0 9.125 7.02" />
              <path stroke-linejoin="round" d="m3.75 12.5l2.5-2.5l2.5 2.5m6.5-1l2.5 2.5l2.5-2.5" />
            </g>
          </svg>
        </span>

        <div class="search-container" [class.expanded]="searchExpanded">
          <!-- Search Icon (always visible) -->
          <span class="search-icon actionIcon" (click)="toggleSearch()" aria-label="Open search" *ngIf="!searchExpanded"
            matTooltip="search" matTooltipPosition="above">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
              <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" stroke-width="2" />
            </svg>
          </span>

          <!-- mat-form-field input + close icon, shown on expand -->
          <mat-form-field appearance="outline" class="search-field" *ngIf="searchExpanded">
            <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="#0075C9" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
              </svg>
            </span>
            <input matInput placeholder="Search " [(ngModel)]="searchQuery" (input)="onSearch()"   #myInput autofocus />
            <span (click)="toggleSearch()" class="cursor-pointer close-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.5"
                  d="m8.464 15.535l7.072-7.07m-7.072 0l7.072 7.07" />
              </svg>
            </span>
          </mat-form-field>
        </div>


        <button class="primaryBtn" (click)="openRequestME('')">
          <span class="btnContent">New ME Request</span>
        </button>
        <!-- <button class="secondaryBtn" (click)="openAddMedicalProviderModal()">
          <span class="btnContent">New ME Provider</span>
        </button> -->
        <button class="secondaryBtn" (click)="openBulkUploadModal()">
          <span class="btnContent">Applicants Bulk Upload</span>
        </button>
      </div>
      }
    </div>
  </div>


  <!-- Card Section -->
  <div class="content flex-grow-1 overflow-auto">
    @if (isDataLoading) {
    <div class="custom-card">
      <div class="loader-pro">
        <app-loader></app-loader>
      </div>
    </div>
    } @else if (renderData.length > 0 ) {

    <ng-container *ngIf="viewMode === 'grid'; else listView">
      <app-table-card-view [data]="renderData" [enumRole]="enumRole" [enumEntityType]="enumEntityType"
        [getTurnAroundTime]="getTurnAroundTime" (openPatientProfile)="openPatientProfile($event)"
        (openMedicalEvidence)="openMedicalEvidence($event)" (openRequestMoreDetails)="onRequestMoreDetails($event)"
        (openAddPatientModal)="openAddPatientModal($event)" (openRequestME)="openRequestME($event)"
        (onFillMoreInfo)="onFillMoreInfo($event)" (onViewDocuments)="onViewDocuments($event)">
      </app-table-card-view>
    </ng-container>
    <ng-template #listView>
      <app-table-list-view [data]="dataSource.data" [displayedColumns]="displayedColumns"
        [columnDisplayNames]="columnDisplayNames" [enumEntityType]="enumEntityType"
        [getTurnAroundTime]="getTurnAroundTime" (openPatientProfile)="openPatientProfile($event)"
        (openMedicalEvidence)="openMedicalEvidence($event)" (openRequestMoreDetails)="onRequestMoreDetails($event)"
        (openAddPatientModal)="openAddPatientModal($event)" (openRequestME)="openRequestME($event)"
        (onFillMoreInfo)="onFillMoreInfo($event)" (onViewDocuments)="onViewDocuments($event)">
      </app-table-list-view>
    </ng-template>
    }
    @else {
    <div class="custom-card">
      <app-no-data-found></app-no-data-found>
    </div>
    }
  </div>
</div>